import { Col, Row, } from "antd";
import GeneralLoadingSpinner from "apps/Common/GeneralLoadingSpinner";
import { useGetContractByType } from "apps/CustomerPanel/Ad/ServerSideStates";
import { FC } from "react";
import { Helmet } from "react-helmet-async";
const SubscriptionAgreement: FC<{ containerClassNames?: string }> = ({ containerClassNames }) => {

  const contract = useGetContractByType("1")

  const html = contract?.data?.data?.content || "";
  return (
    <Col xs={24}>
      <Helmet>
        <title className="capitalize">{"Bireysel Hesap Sözleşmesi"}</title>
      </Helmet>
      <Row className={containerClassNames ? containerClassNames : ""} gutter={[20, 20]}>
        {contract.isLoading ? (
          <>
            <GeneralLoadingSpinner />
          </>
        ) : (
          <>
            <Col xs={24}>

              <div dangerouslySetInnerHTML={{ __html: html }} />
            </Col>
          </>
        )}
      </Row>

    </Col>
  );
};

export default SubscriptionAgreement;
